import { ListItemText, ListItemTextProps } from '@mui/material'

export const TargetPriceTooltipListItemText = (props: ListItemTextProps) => {
  return (
    <ListItemText
      {...props}
      slotProps={{
        primary: {
          component: 'span',
          sx: {
            fontSize: (theme) => theme.typography.caption.fontSize,
          },
        },
        secondary: {
          component: 'span',
          sx: {
            fontSize: (theme) => theme.typography.body2.fontSize,
            color: (theme) => theme.typography.body2.color,
          },
        },
      }}
    />
  )
}
